import React, { useState } from 'react';
import classNames from 'classnames';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useObserver } from 'mobx-react';

import { useDisabledState } from 'common/disabled-context';
import useSession from 'core/hooks/use-session';
import ValueField from 'core/components/value-field';
import { currencyFormatter, awsDateToDateFormatter } from 'core/helpers/formatters';
import { useStore } from 'core/store';
import { Button } from 'core/components/button';
import useFeeUpdater from './use-fee-updater';
import useStyles from './styles';

function FeeRow({ fee }) {
  const [undo, setUndo] = useState(false);
  const { isExternalSales, isService, isInternalAgent, viewOnly } = useSession();
  const { updateFees } = useFeeUpdater();
  const {
    account: {
      policies: {
        policy: { policy: store }
      }
    }
  } = useStore();
  const readOnly = viewOnly || isExternalSales;
  const classes = useStyles({ readOnly });
  const { disabled } = useDisabledState();

  const toggleForRemoval = () => {
    fee.toggleMarkedForRemoval();
    updateFees();
    if (fee.status === 'removed') {
      setUndo(true);
    } else {
      setUndo(!undo);
    }
  };

  function variableFeePlaceholder(fee) {
    if (store.state === 'AL' && fee.type === 'installment' && fee.status !== 'pre-existing') {
      return '?';
    }
    return fee.amount;
  }

  return useObserver(() => (
    <TableRow className={classNames(classes.normal, { [classes.undo]: undo })}>
      <TableCell>
        <ValueField
          className={classes.valueField}
          value={`${fee.description?.substring(0, 35)}${fee.description.length > 35 ? '...' : ''}`}
          mode="alwaysDark"
          label="type"
        />
      </TableCell>
      <TableCell>
        <ValueField
          className={classes.valueField}
          formatter={currencyFormatter}
          value={variableFeePlaceholder(fee)}
          mode="alwaysDark"
          label="amount"
        />
      </TableCell>
      <TableCell>
        <ValueField
          className={classes.valueField}
          formatter={awsDateToDateFormatter}
          value={
            fee.appliedDate?.includes(',')
              ? fee.appliedDate
                  .split(',')[0]
                  .replaceAll('[', '')
                  .replaceAll(`"`, '') // fix bad data
              : fee.appliedDate
          }
          mode="alwaysDark"
          label="date added"
        />
      </TableCell>

      {!readOnly && (
        <TableCell align="center">
          <Button
            className={classes.removeButton}
            variant="text"
            color="secondary"
            onClick={toggleForRemoval}
            disabled={!isService || !isInternalAgent || disabled}
          >
            {undo ? 'Undo' : 'Remove Fee'}
          </Button>
        </TableCell>
      )}
    </TableRow>
  ));
}

export default FeeRow;
